import { ILLGenericKeys } from './ll-generic-keys.model';
import { ISSDPConctact } from './ssdp-contact.model';

export class ILLCompany {
 splTitle: string;
 ndcLabelerCode: string;
 majorRevision: number;
 minorRevision: number;
 companyId: string;
 companyRevisionId: number;
 companyName: string;
 type: string;
 dunsNumber: string;
 fei: string;
 address: string;
 city: string;
 country: ILLGenericKeys;
 state: string;
 zip: string;
 businessCategory: ILLGenericKeys;
 companyType: ILLGenericKeys[];
 notes: string;
 registrantConfidentiality: string;
 establishmentConfidentiality: string;
 businessOperations: ILLGenericKeys[];
 ndcLabelerCodes: ILLGenericKeys[];
 contacts: ISSDPConctact[];
}
